import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';

export const emailConfigurationRowStyles = StyleSheet.create({
	container: {
		borderBottom: THEME.common.border,
		paddingTop: THEME.spacing.sm,
		paddingBottom: THEME.spacing.lg,
	},
	section: {
		marginTop: THEME.spacing.sm,
	},
	header: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
		fontWeight: THEME.typography.fontWeights.semibold,
		marginBottom: THEME.spacing.xs,
	},
	fields: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
		gap: THEME.spacing.sm,
	},
	sendOptions: {
		display: 'flex',
		flexDirection: 'row',
	},
	label: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xxs,
		marginBottom: THEME.spacing.xs,
		display: 'block',
	},
	limitField: {
		display: 'flex',
		flexDirection: 'column',
	},
	hostName: {
		flex: 1,
		minWidth: 150,
	},
	exchangeUrl: {
		flex: 1,
		minWidth: 220,
	},
	portNumber: {
		width: 90,
	},
	sendLimit: {
		width: 90,
	},
	secondsInput: {
		width: 140,
	},
	selectTrigger: {
		flex: 1,
		minWidth: 200,
	},
	checkboxRow: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.sm,
	},
	checkboxLabel: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
		cursor: 'pointer',
	},
	smtpOnly: {
		marginTop: THEME.spacing.sm,
	},
	smtpOnlyWarning: {
		color: THEME.colors.danger.main,
		fontSize: THEME.typography.fontSizes.xs,
	},
	unsupportedISP: {
		margin: `${THEME.spacing.sm}px 0`,
	},
	autoDiscoverButton: {
		marginTop: THEME.spacing.md,
		paddingLeft: 0,
	},
	dialogPopup: {
		left: '50%',
		top: '50%',
		translate: '-50% -50%',
		width: '100%',
		maxWidth: 480,
	},
	dialogBody: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		marginTop: THEME.spacing.sm,
	},
	inputRow: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.sm,
	},
	dialogResults: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
		marginTop: THEME.spacing.sm,
	},
	dialogValue: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
	},
	dialogError: {
		color: THEME.colors.danger.main,
		fontSize: THEME.typography.fontSizes.sm,
	},
	useConfigButton: {
		marginTop: THEME.spacing.sm,
		alignSelf: 'flex-start',
	},
});
